module.exports = require('./dist/server/lib/useBreadcrumbs');
